import { render, staticRenderFns } from "./automated_notifications.vue?vue&type=template&id=d8db7c32&"
import script from "./automated_notifications.vue?vue&type=script&lang=js&"
export * from "./automated_notifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports